import { pipe } from 'fp-ts/lib/function';
import { chain, map } from 'fp-ts/lib/TaskEither';
import { listCodec } from './codec';
import {
  createAuthorizedGetRequest,
  createAuthorizedPostRequest,
  createPostRequest,
  decode,
  fetchApi,
  jsonHeaders,
  setBody,
  setQuery,
} from '../..';
import { encodePaginatableQuery, PaginatableQuery } from '../../request';
import { filterCodec } from '@/services/api/resources/filter';
import { SectionFilterPayload } from '@/entities/section';

const baseUrl = '/v2/sections';
const filterUrl = '/v2/filters/sections';
const analyticsUrl = '/v2/analytics/filters/sections';
const publicAnalyticsUrl = (id: number) => `/v2/public/analytics/filters/${id}/sections`;

export const list = (query: PaginatableQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery({
    ...encodePaginatableQuery(query),
    hasTitle: '1',
  })),
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const filter = () => pipe(
  filterUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(filterCodec)),
);

export const analyticsFilter = (payload: SectionFilterPayload) => pipe(
  analyticsUrl,
  createAuthorizedPostRequest,
  map(setBody(payload)),
  chain(fetchApi),
  chain(decode(filterCodec)),
);

export const publicAnalyticsFilter = (reportId: number, payload: SectionFilterPayload) => pipe(
  publicAnalyticsUrl(reportId),
  jsonHeaders(createPostRequest),
  setBody(payload),
  fetchApi,
  chain(decode(filterCodec)),
);
